// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Map_tooltip__dC-yA"};